import { render, staticRenderFns } from "./GroupInput.vue?vue&type=template&id=63b1432c&"
import script from "./GroupInput.vue?vue&type=script&lang=js&"
export * from "./GroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports